	 <h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
<div class="content" >
      <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
        <div *ngIf="success || error" tamsyMargin marginY="10px">
          <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
          <esl-message-toast [(message)]="error"></esl-message-toast>
        </div>
        <div appMargin marginB="5">Description</div>
        <div *ngFor="let item of audit | keyvalue">
          {{item.key}} - {{item.value}}
        </div>

      </div>
</div>

      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
            <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()" autofocus>Done</button>

      </div>


